// extracted by mini-css-extract-plugin
export default {"wrapper":"startPopup_wrapper__Vtuux","body":"startPopup_body__E4prV","title":"startPopup_title__4D9-Q","buttonStart":"startPopup_buttonStart__7OBhR"};